function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash/fp';
import React, { Fragment, useContext, useEffect, useMemo } from 'react';
import { Collapse } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import T from 'prop-types';
import { toggleAutomaticDataTableVisibility, toggleManualDataTableVisibility } from '../../redux/actions';
import text, { formatCurrency } from '../../text';
import { isSelectionAutomatic, isSelectionManual } from '../../utilities/selection';
import Icon from '../icon/Icon';
import { getAddOnConfig } from '../mapView/drawingManager/utilities';
import { MapViewContext } from '../mapView/mapViewContext';
import DataTable from '../table/dataTable/DataTable';
import CartEmpty from './CartEmpty';
import OtherChargeRow from './OtherChargeRow';
import ProductTable, { ProductTableHeader } from './ProductTable';
export default function CartTable(props) {
    var _state_job, _state_job1, _state_job2;
    var isReadOnly = props.isReadOnly;
    var state = useContext(MapViewContext).state;
    var dispatch = useDispatch();
    var layout = useSelector(function(reduxState) {
        return {
            layout: reduxState.layout
        };
    }).layout;
    var selectionsPerProduct = useMemo(function() {
        var products = new Map();
        if (state.selections) {
            state.selections.forEach(function(selection) {
                if (products === null || products === void 0 ? void 0 : products[selection.category_name]) {
                    products[selection.category_name] = _to_consumable_array(products[selection.category_name]).concat([
                        selection
                    ]);
                } else {
                    products[selection.category_name] = [
                        selection
                    ];
                }
            });
        }
        return products;
    }, [
        state.selections
    ]);
    var automaticProducts = useMemo(function() {
        return Object.entries(selectionsPerProduct).filter(function(product) {
            return isSelectionAutomatic(product[1][0]);
        });
    }, [
        selectionsPerProduct
    ]);
    var manualProducts = useMemo(function() {
        return Object.entries(selectionsPerProduct).filter(function(product) {
            var _product__;
            var isAddOn = !!getAddOnConfig((_product__ = product[1][0]) === null || _product__ === void 0 ? void 0 : _product__.category_name);
            return isSelectionManual(product[1][0]) && !isAddOn;
        });
    }, [
        selectionsPerProduct
    ]);
    var addOnProducts = useMemo(function() {
        return Object.entries(selectionsPerProduct).filter(function(product) {
            var _product__;
            var isAddOn = !!getAddOnConfig((_product__ = product[1][0]) === null || _product__ === void 0 ? void 0 : _product__.category_name);
            return isSelectionManual(product[1][0]) && isAddOn;
        });
    }, [
        selectionsPerProduct
    ]);
    var chargesPerProduct = useMemo(function() {
        var _state_job_quote, _state_job;
        var products = new Map();
        if ((_state_job = state.job) === null || _state_job === void 0 ? void 0 : (_state_job_quote = _state_job.quote) === null || _state_job_quote === void 0 ? void 0 : _state_job_quote.charges) {
            state.job.quote.charges.forEach(function(charge) {
                products[charge.display_name] = _object_spread({}, charge);
            });
        }
        return products;
    }, [
        state.job
    ]);
    // TODO: use context
    var coveragePerProduct = useMemo(function() {
        var _state_job_coverage, _state_job;
        var products = {};
        if ((_state_job = state.job) === null || _state_job === void 0 ? void 0 : (_state_job_coverage = _state_job.coverage) === null || _state_job_coverage === void 0 ? void 0 : _state_job_coverage.selections) {
            _.forEach(function(selection) {
                if (selection.category_name in products) {
                    products[selection.category_name].push(selection);
                } else {
                    products[selection.category_name] = [
                        selection
                    ];
                }
            })(state.job.coverage.selections);
        }
        return products;
    }, [
        state.job
    ]);
    var siteDeploymentFee = useMemo(function() {
        var _state_job_quote, _state_job, _state_job_quote1, _state_job1, _state_job_quote2, _state_job2;
        var fee = (_state_job = state.job) === null || _state_job === void 0 ? void 0 : (_state_job_quote = _state_job.quote) === null || _state_job_quote === void 0 ? void 0 : _state_job_quote.fees.find(function(fee) {
            return fee.id === 'site_deployment_fee';
        });
        return fee ? !isNaN(fee.price.total) ? formatCurrency(fee.price.total, (_state_job1 = state.job) === null || _state_job1 === void 0 ? void 0 : (_state_job_quote1 = _state_job1.quote) === null || _state_job_quote1 === void 0 ? void 0 : _state_job_quote1.currency.name, (_state_job2 = state.job) === null || _state_job2 === void 0 ? void 0 : (_state_job_quote2 = _state_job2.quote) === null || _state_job_quote2 === void 0 ? void 0 : _state_job_quote2.currency.scale_factor, {}, true) : text('toBeConfirmed') : '';
    }, [
        state.job
    ]);
    useEffect(function() {
        // note that whenever the automatic/manual data table is visible
        // the add-on button is not visible, and vice versa
        var isAutomaticDataAdded = state.selections.some(function(selection) {
            return selection.delivery_method === 'automatic';
        });
        dispatch(toggleAutomaticDataTableVisibility(isAutomaticDataAdded));
        var isManualDataAdded = state.selections.some(function(selection) {
            return selection.delivery_method === 'manual';
        });
        dispatch(toggleManualDataTableVisibility(isManualDataAdded));
    }, [
        dispatch,
        state.selections
    ]);
    var hasAddOns = state.hasAddOns && !isReadOnly;
    return /*#__PURE__*/ React.createElement("div", {
        className: "CartTableV2"
    }, state.isCartEmpty ? /*#__PURE__*/ React.createElement(CartEmpty, {
        hasAddOns: hasAddOns
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("hr", {
        className: "my-2"
    }), /*#__PURE__*/ React.createElement("h3", {
        className: "title green-1"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "shopping-cart"
    }), text('cart')), /*#__PURE__*/ React.createElement("hr", {
        className: "my-2"
    })), /*#__PURE__*/ React.createElement(ProductGroup, {
        headerText: text('buyNowDataInDatabase'),
        isVisible: layout.automaticDataTable.isVisible,
        products: automaticProducts,
        selectionsPerProduct: selectionsPerProduct,
        chargesPerProduct: chargesPerProduct,
        coveragePerProduct: coveragePerProduct,
        isReadOnly: isReadOnly,
        quote: (_state_job = state.job) === null || _state_job === void 0 ? void 0 : _state_job.quote
    }), /*#__PURE__*/ React.createElement(ProductGroup, {
        headerText: text('getQuoteData'),
        isVisible: layout.manualDataTable.isVisible,
        products: manualProducts,
        selectionsPerProduct: selectionsPerProduct,
        chargesPerProduct: chargesPerProduct,
        coveragePerProduct: coveragePerProduct,
        isReadOnly: isReadOnly,
        quote: (_state_job1 = state.job) === null || _state_job1 === void 0 ? void 0 : _state_job1.quote,
        siteDeploymentFee: siteDeploymentFee
    }), /*#__PURE__*/ React.createElement(ProductGroup, {
        headerText: text('getQuoteAddOns'),
        isVisible: addOnProducts.length > 0,
        products: addOnProducts,
        selectionsPerProduct: selectionsPerProduct,
        chargesPerProduct: chargesPerProduct,
        coveragePerProduct: coveragePerProduct,
        isReadOnly: isReadOnly,
        quote: (_state_job2 = state.job) === null || _state_job2 === void 0 ? void 0 : _state_job2.quote
    }));
}
CartTable.propTypes = {
    isReadOnly: T.bool
};
var ProductGroup = function(param) {
    var headerText = param.headerText, isVisible = param.isVisible, products = param.products, selectionsPerProduct = param.selectionsPerProduct, chargesPerProduct = param.chargesPerProduct, coveragePerProduct = param.coveragePerProduct, isReadOnly = param.isReadOnly, quote = param.quote, siteDeploymentFee = param.siteDeploymentFee;
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ProductTableHeader, {
        headerText: headerText
    }), /*#__PURE__*/ React.createElement(Collapse, {
        in: isVisible
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(DataTable, {
        className: "DataTableV2"
    }, Object.keys(selectionsPerProduct).length > 0 && quote ? /*#__PURE__*/ React.createElement(Fragment, {
        key: "wrapper"
    }, /*#__PURE__*/ React.createElement("tbody", null, products.map(function(product, index) {
        return /*#__PURE__*/ React.createElement(ProductTable, {
            key: index,
            product: product,
            chargesPerProduct: chargesPerProduct,
            coveragePerProduct: coveragePerProduct,
            isReadOnly: isReadOnly,
            index: index
        });
    }), siteDeploymentFee ? /*#__PURE__*/ React.createElement(OtherChargeRow, {
        isReadOnly: isReadOnly,
        description: text('siteDeploymentFee'),
        amount: siteDeploymentFee,
        infoMessage: text('siteDeploymentFeeInfo')
    }) : null)) : null))));
};
ProductGroup.propTypes = {
    headerText: T.string,
    isVisible: T.bool,
    products: T.oneOfType([
        T.object,
        T.array
    ]),
    selectionsPerProduct: T.object,
    chargesPerProduct: T.object,
    coveragePerProduct: T.object,
    isReadOnly: T.bool,
    quote: T.object,
    siteDeploymentFee: T.oneOfType([
        T.string,
        T.number
    ])
};
